import { Link } from "react-router-dom";
import { HELP_THEME } from "@/help/helpContent";

// The "?" button shown in the header on every page (signed in or not). Opens the public user guide at /help.
export default function HelpButton() {
  return (
    <Link
      to="/help"
      data-testid="help-button"
      aria-label="Help: user guide and FAQ"
      title="Help: user guide and FAQ"
      className={HELP_THEME.button}
    >
      ?
    </Link>
  );
}
